import { Box } from '@jfs/ui-new';
import { AepsButton } from '../AepsButton';
type AuthMode = 'FINGER_PRINT' | 'FACE';
interface ScanUserAuthProps {
  onPress: (authMode: AuthMode) => any
  isLoading: boolean
  disabled?: boolean
  allowedModes?: AuthMode[] 
}
export const ScanUserAuth = ({ 
  onPress, 
  isLoading, 
  disabled, 
  allowedModes = ['FINGER_PRINT', 'FACE']
}: ScanUserAuthProps) => {
  const showFingerprint = allowedModes.includes('FINGER_PRINT');
  const showFace = allowedModes.includes('FACE');

  return (
    <Box flexDirection={'row'}>
      {showFingerprint && (
        <Box f={1}>
          <AepsButton
            onPress={() => onPress('FINGER_PRINT')}
            title={'Scan Fingerprint'}
            isLoading={isLoading}
            disabled={disabled}
            iconId={'FINGERPRINT'}
          />
        </Box>
      )}
      {showFingerprint && showFace && <Box style={{ width: 32 }} />}
      {showFace && (
        <Box f={1}>
          <AepsButton
            onPress={() => onPress('FACE')}
            title={'Scan Face'}
            isLoading={isLoading}
            disabled={disabled}
            iconId="CAMERA"
          />
        </Box>
      )}
    </Box>
  )
}